import classNames from './ImproveActivity.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import { gameSelector } from '@/store/reducers/game';
import { unitSelector } from '@/store/reducers/unit';
import UseScreenSize from '@/hooks/UseScreenSize';
import QuizBadge from '../QuizBadge/QuizBadge';
import medalGold from '@/assets/svg/medal-gold.svg';
import QuizScore from '../QuizScore/QuizScore';
import rightArrow from '@/assets/svg/right-arrow.svg';
import SVG from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom';
import { ImprovableRecentActivities, ImprovableRecentActivity } from '@/types/progress';
import { getQuizByActivity } from './getQuizByActivity';

interface ImproveActivityProps {
  activities: ImprovableRecentActivities;
}

const ImproveActivity = ({ activities }: ImproveActivityProps) => {
  const { t } = useTranslation();
  const { isDesktop } = UseScreenSize();
  const { interfaceLanguage, skillSettings } = useAppSelector(authSelector);
  const { selectedType, selectedTopic: gameSelectedTopic } = useAppSelector(gameSelector);
  const { selectedUnit } = useAppSelector(unitSelector);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isRtlLanguage =
    interfaceLanguage && ['he', 'ar'].includes(interfaceLanguage) ? true : false;

  const handleActivityClick = (activity: ImprovableRecentActivity) =>
    getQuizByActivity({
      activity,
      dispatch,
      navigate,
      selectedType,
      skillSettings,
      selectedUnit,
      gameSelectedTopic,
    });

  return (
    <div className={classNames.improveActivity}>
      {activities && isDesktop && (
        <>
          <h2>{t('improveYourLastActivities')}</h2>
          <span className={classNames.description}>{t('tryToGetAllStars')}</span>
          <ul className={classNames.activityList}>
            {activities.map((activity, index) => (
              <li
                key={activity.activityId}
                className={classNames.activityItem}
                onClick={() => handleActivityClick(activity)}
              >
                <div className={classes(classNames.activityDetails, classNames.divider_container)}>
                  <div className={classNames.medalIcon}>
                    <QuizBadge img={medalGold} isLocked={false} index={index} isExtraSmall={true} />
                    <QuizScore
                      isLocked={false}
                      achievedStars={activity.achievedStars ?? 0}
                      isExtraSmall={true}
                    />
                  </div>
                  <span className={classes(classNames.activityName, classNames.text)}>
                    {activity.activityName}
                  </span>
                  <span className={classes(classNames.verticalSeparator, classNames.divider)}>
                    |
                  </span>
                  <span className={classes(classNames.topicName, classNames.text)}>
                    {activity.topicName}
                  </span>
                </div>
                {!isRtlLanguage ? (
                  <span className={classNames.arrowIcon}>
                    <SVG src={rightArrow} />
                  </span>
                ) : (
                  ''
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default ImproveActivity;
